export default {"src":"/_next/static/media/in_filled.7319eea6.svg","height":24,"width":24};